/*
 * fs-hero.js — the hero slide set, and the timer that advances it.
 *
 * AUTO-ROTATION'S BAD REPUTATION IS EARNED. It takes the sentence away halfway
 * through reading it and it moves the button out from under the cursor. Three
 * things defuse that here, and all three are load-bearing:
 *
 *   · a progress bar fills the selected button, so the change is announced
 *     rather than sprung
 *   · it PAUSES while the pointer is over the hero, or focus is inside it —
 *     nobody loses a sentence they are reading or a button they are aiming at
 *   · it STOPS FOR GOOD once the shopper presses a slide button. They have said
 *     which slide they want; taking it away again is the rude version
 *
 * It is off entirely under `prefers-reduced-motion`, and the merchant can
 * switch it off in the editor.
 *
 * ⚠️ HIDDEN MUST WIN — `[hidden]{display:none !important}` is declared against
 * the slide's own class in the stylesheet. This theme has shipped a band where
 * two groups both carried `hidden` and both painted.
 *
 * With this file absent the first slide shows and the buttons do nothing.
 */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-fs-hero]').forEach(function (hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-fs-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-fs-hero-dot]'));
    if (slides.length < 2 || !dots.length) return;

    var dotWrap = hero.querySelector('.fs-banner__dots');
    var delay = (Number(hero.getAttribute('data-fs-hero-delay')) || 6) * 1000;
    var auto = hero.getAttribute('data-fs-hero-autoplay') === 'true' && !REDUCED;
    var timer = null;
    var stopped = false;
    var paused = false;
    var index = 0;

    function bar(i) {
      var d = dots[i];
      return d && d.querySelector('.fs-banner__progress');
    }

    function resetBars() {
      dots.forEach(function (d) {
        var b = d.querySelector('.fs-banner__progress');
        if (b) b.classList.remove('is-running');
      });
    }

    function runBar() {
      resetBars();
      if (!auto || stopped || paused) return;
      var b = bar(index);
      if (!b) return;
      /* Two frames: one for the class removal to take effect, one to start the
         transition from zero. With a single frame the browser coalesces both
         and the bar jumps straight to full. */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { b.classList.add('is-running'); });
      });
    }

    function show(i, moveFocus) {
      index = i;
      slides.forEach(function (s) {
        if (s.getAttribute('data-fs-hero-slide') === String(i)) s.removeAttribute('hidden');
        else s.setAttribute('hidden', '');
      });
      dots.forEach(function (d) {
        d.setAttribute('aria-selected', String(d.getAttribute('data-fs-hero-dot') === String(i)));
      });
      if (moveFocus && dots[i]) dots[i].focus();
      runBar();
    }

    function schedule() {
      window.clearTimeout(timer);
      if (!auto || stopped || paused) return;
      timer = window.setTimeout(function () {
        show((index + 1) % slides.length, false);
        schedule();
      }, delay);
    }

    /* Pressing a button is the shopper choosing. The timer does not come back. */
    hero.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('[data-fs-hero-dot]');
      if (!dot) return;
      stopped = true;
      window.clearTimeout(timer);
      resetBars();
      show(Number(dot.getAttribute('data-fs-hero-dot')), false);
    });

    hero.addEventListener('keydown', function (e) {
      var dot = e.target.closest && e.target.closest('[data-fs-hero-dot]');
      if (!dot) return;
      var i = dots.indexOf(dot);
      var next = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % dots.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + dots.length) % dots.length;
      if (next < 0) return;
      e.preventDefault();
      stopped = true;
      window.clearTimeout(timer);
      resetBars();
      show(next, true);
    });

    function pause(on) {
      if (paused === on) return;
      paused = on;
      if (dotWrap) dotWrap.setAttribute('data-paused', String(on));
      if (on) { window.clearTimeout(timer); resetBars(); }
      else { runBar(); schedule(); }
    }

    hero.addEventListener('pointerenter', function () { pause(true); });
    hero.addEventListener('pointerleave', function () { pause(false); });
    hero.addEventListener('focusin', function () { pause(true); });
    hero.addEventListener('focusout', function () {
      if (!hero.contains(document.activeElement)) pause(false);
    });

    /* A timer that keeps firing on a background tab wakes up having missed
       twenty turns and flickers through them. */
    document.addEventListener('visibilitychange', function () { pause(document.hidden); });

    if (auto) { runBar(); schedule(); }
  });
})();
